import React, { useEffect, useState } from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import SummaryApi from '../common';
import moment from 'moment';
import displayINRCurrency from '../helpers/displayCurrency';
import { MdModeEdit, MdOutlineDoneOutline } from 'react-icons/md'; // Edit Iconn
import { useSelector } from 'react-redux';
import ChangeSalesMan from '../components/ChangeSalesMan';
import ChangeOrderStatus from '../components/ChangeOrderStatus';
import { CiDeliveryTruck, CiTimer } from 'react-icons/ci';
import { FaEye } from 'react-icons/fa6';
import { RiRefund2Fill } from "react-icons/ri";
import ROLE from '../common/role';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { HiXCircle } from "react-icons/hi";


const AdminAllOrders = () => {
    const [loadingPage, setLoadingPage] = useState(false);
    const location = useLocation();
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const user = useSelector(state => state?.user?.user);
    const [currentSalesman, setCurrentSalesman] = useState(''); 
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [showChangeSalesMan, setShowChangeSalesMan] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState('');
    const navigate = useNavigate();

      // Default startDate and endDate for the current month
  const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));

  const fetchDeptRequestDetails = async () => {
    try {
      setLoading(true); // Set loading to true before fetching data
  
      const body = {
        type: user?.type, 
        startDate: startDate ? moment(startDate).toISOString() : '',
        endDate: endDate ? moment(endDate).toISOString() : ''
      };
  
      const response = await fetch(`${SummaryApi.allOrder.url}`, {
        method: 'POST', 
        credentials: 'include',
        headers: {
          "Content-Type": 'application/json'
        },
        body: JSON.stringify(body)
      });
  
      const responseData = await response.json();
      if (responseData.success) {
        setData(responseData.data || []);
      } else {
        setError(responseData.message);
        setData([]);
      }
    } catch (error) {
      setError('Error fetching dept requests');
      setData([]);
    } finally {
      setLoading(false); // Ensure loading is set to false after data is fetched or an error occurs
    }
  };
  
  

    



    useEffect(() => {
        fetchDeptRequestDetails();
        
    }, [startDate, endDate]);

    const getStatusColor = (status) => {
        switch (status) {
            case 'accepted':
                return 'bg-blue-700 text-white';
            case 'pending':
                return 'bg-yellow-600 text-white';
            case 'rejected':
                return 'bg-red-800 text-white';
            case 'done':
                return 'bg-green-900 text-white';
            default:
                return 'bg-gray-700 text-white';
        }
    };
    const refreshData = async () => {
        await fetchDeptRequestDetails();
        
    };
    const closeModal = () => {
      setSelectedOrderId(null);
      setSelectedStatus('');
      setShowChangeSalesMan(false); 
    };
    const handleChangeSalesManClick = (orderId, salesManName) => {
      setSelectedOrderId(orderId);
      setCurrentSalesman(salesManName || '');
      setShowChangeSalesMan(true);
    };
    const handleStatusClick = (orderId, currentStatus) => {
      setSelectedOrderId(orderId);
      setSelectedStatus(currentStatus);
      setShowChangeSalesMan(false); 
    };
    const handleViewOrder = (orderId) => {
      navigate(`/admin-panel/adminViewAnOrder/${orderId}/${user?.type}`);
  };
    

  useEffect(() => {
    setLoadingPage(true);
    const loadingTimeout = setTimeout(() => {
      
      setLoadingPage(false);
      navigate("/");
    }, 10000); 

    if (user) {
      if (user?.role !== ROLE.ADMIN) {
        navigate('/');
        setLoadingPage(false);
      } 
      else {
        if(user?.type === "Admin"){
            navigate('/admin-panel/all-users');
            setLoadingPage(false);
        }
        else{
            setLoadingPage(false);
            clearTimeout(loadingTimeout);
        }
       
      }
    } 

    // Clear the timeout when the component unmounts or the effect is rerun
    return () => clearTimeout(loadingTimeout);
  }, [user, navigate]);

  if (loadingPage) {
    return (
        <div className="flex justify-center items-center h-screen">
            <AiOutlineLoading3Quarters className="animate-spin text-6xl text-blue-500" />
        </div>
    );
}

    return (
        <div className='bg-white pb-4 px-4'>
            {loading ? (
                <p>Loading...</p>
            ) : error ? (
                <p>{error}</p>
            ) : (
                <>


                {/* Date Filter Section */}
                  <div className="flex justify-end items-start mb-4">
                    <div className="text-right">
                      <h2 className="text-xl font-bold mb-6">حدد المدة التي تريد ان تري بها جميع الطلبات </h2>

                      <div className="flex gap-6 justify-end">
                        {/* Start Date */}
                        <div>
                          <label htmlFor="startDate" className="block text-sm font-medium text-gray-700">
                            تاريخ البداية
                          </label>
                          <input
                            type="date"
                            id="startDate"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
                          />
                        </div>

                        {/* End Date */}
                        <div>
                          <label htmlFor="endDate" className="block text-sm font-medium text-gray-700">
                            تاريخ النهاية
                          </label>
                          <input
                            type="date"
                            id="endDate"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                            className="mt-1 p-2 block w-full border border-gray-300 rounded-md"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                    {data?.length === 0 ? (
                        <p>لا يوجد طلبات حاليا </p>
                    ) : (
                        <div className='overflow-x-auto'>
                            <table className='w-full border-collapse border border-gray-300'>
                                <thead>
                                    <tr className='bg-black text-white'>
                                        <th className='py-2 px-2 border border-gray-300'>كود الطلب</th>
                                        <th className='py-2 px-2 border border-gray-300'>اسم الصيدلية</th>                 
                                        <th className='py-2 px-2 border border-gray-300'>عنوان الصيدلية </th>
                                        <th className='py-2 px-2 border border-gray-300'>تاريخ الفاتورة</th>
                                        <th className='py-2 px-2 border border-gray-300'>الكمية</th>
                                        <th className='py-2 px-2 border border-gray-300'>اسم مندوب المبيعات</th>
                                        <th className='py-2 px-2 border border-gray-300'>هاتف مندوب المبيعات</th>
                                       {/* <th className='py-2 px-2 border border-gray-300'>البريد الالكترونى لمندوب المبيعات</th> */}
                                        <th className='py-2 px-2 border border-gray-300'>حالة الطلب</th>
                                        <th className='py-2 px-2 border border-gray-300'> تفاصيل الطلب</th>
                                        
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={item._id || index} className="min-h-[80px] border-t border-gray-300">
                                            <td className="text-center py-1 px-2 border border-gray-300">#{item.orderCode}</td>
                                            <td className="text-center py-1 px-2 border border-gray-300">{item.userName}</td>
                                            <td className="text-center py-1 px-2 border border-gray-300">{item.userShippingAddress}</td>
                                            <td className="text-center py-1 px-2 border border-gray-300">{moment(item.createdAt).format('LLL')}</td>
                                            <td className="text-center py-1 px-2 border border-gray-300">{displayINRCurrency(item.totalPrice || 0)}</td>
                                            <td className="text-center py-1 px-2 border border-gray-300">
                                                <div className="flex items-center justify-center space-x-2">
                                                  {/* Display the salesManName or default message */}
                                                  <span>
                                                    {item.salesManName === '' ? 'لم يتم تحديد مندوب مبيعات بعد' : item.salesManName}
                                                  </span>

                                                  {/* Show the edit button if status is 'accepted' */}
                                                  {item.status === 'accepted'&&item.type==='order' && (
                                                    <button
                                                      className="bg-blue-100 p-2 rounded-full cursor-pointer hover:bg-blue-500 hover:text-white flex items-center justify-center"
                                                      onClick={() => handleChangeSalesManClick(item._id, item.salesManName)}
                                                    >
                                                      <MdModeEdit className="text-xl" />
                                                    </button>
                                                  )}
                                                </div>
                                              </td>

                                              <td className="text-center py-1 px-2 border border-gray-300">{item.salesManMobileNumber === '' ? 'لم يتم تحديد مندوب مبيعات بعد' : item.salesManMobileNumber}</td>
                                           {/*<td className="text-center py-1 px-2 border border-gray-300">{item.salesManEmail === '' ? 'لم يتم تحديد مندوب مبيعات بعد' : item.salesManEmail}</td>       */}                
                                           <td className="text-center py-1 px-2 border border-gray-300">
                                              {/* Conditional rendering based on status */}
                                              {item.status === 'pending' ? (
                                                <span className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center justify-center">
                                                  <CiTimer className="inline-block mr-2 text-yellow-600 text-2xl" />
                                                  جاري التحضير
                                                  <button
                                                  className="bg-blue-500 p-1 rounded-full cursor-pointer hover:bg-blue-900 ml-2"
                                                  onClick={() => handleStatusClick(item._id, item.status)}
                                                >
                                                  <MdModeEdit size={20} className="text-white" />
                                                </button>
                                                </span>
                                              ) : item.salesManName === '' && item.status === 'accepted' ? (
                                                <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center justify-center">
                                                  <CiDeliveryTruck className="inline-block mr-2 text-yellow-500 text-7xl" />
                                                  تم التحضير بانتظار وضع مندوب مبيعات
                                                  <button
                                                  className="bg-blue-500 p-1 rounded-full cursor-pointer hover:bg-blue-900 ml-2"
                                                  onClick={() => handleStatusClick(item._id, item.status)}
                                                >
                                                  <MdModeEdit size={20} className="text-white" />
                                                </button>

                                                </span>
                                              ) : item.salesManName !== '' && item.status === 'accepted' ? (
                                                <span className="bg-blue-100 text-blue-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center justify-center">
                                                  <CiDeliveryTruck className="inline-block mr-2 text-blue-500 text-5xl" />
                                                 تم التحضير وجاري التوصيل
                                                 <button
                                                  className="bg-blue-500 p-1 rounded-full cursor-pointer hover:bg-blue-900 ml-2"
                                                  onClick={() => handleStatusClick(item._id, item.status)}
                                                >
                                                  <MdModeEdit size={20} className="text-white" />
                                                </button>
                                                </span>
                                              ) : item.status === 'done' ? (
                                                item.type==='order'?
                                                <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center justify-center">
                                                  <MdOutlineDoneOutline className="inline-block mr-2 text-green-500 text-2xl" />
                                                  تم استلام الطلب
                                                  <button
                                                  className="bg-blue-500 p-1 rounded-full cursor-pointer hover:bg-blue-900 ml-2"
                                                  onClick={() => handleStatusClick(item._id, item.status)}
                                                >
                                                  <MdModeEdit size={20} className="text-white" />
                                                </button>
                                                </span>
                                                :item.type==='refund'?
                                                <span className="bg-green-100 text-green-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center justify-center">
                                                <RiRefund2Fill className="inline-block mr-2 text-green-500 text-2xl" />
                                               (مرتجع من الطلب #{item.refundFromOrderNumber}) 
                                              </span>
                                              :""
                                              ) : item.status === 'refused' ? (
                                                
                                                <span className="bg-red-100 text-red-800 px-4 py-2 rounded-lg text-lg font-medium flex items-center justify-center">
                                                  <HiXCircle className="inline-block mr-2 text-red-500 text-2xl" />
                                                  تم رفض الطلب
                                                </span>
                                                
                                              
                                              )
                                              
                                              : (
                                                <span>{item.status}</span>
                                              )}

                                            </td>
                                            <td className="text-center py-2 px-6 border border-gray-300">
                                    <button onClick={() => handleViewOrder(item._id)} className="bg-blue-500 text-white px-4 py-2 rounded-lg">
                                      <FaEye />
                                    </button>
                                  </td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                     {/* ChangeOrderStatus Component for Modal */}
      {selectedOrderId && !showChangeSalesMan && (
      <ChangeOrderStatus
        orderId={selectedOrderId}
        currentStatus={selectedStatus}
        onClose={() => closeModal(false)}
        callFunc={refreshData}
        type={user?.type}
      />
    )}

    {/* ChangeSalesMan Component for Modal */}
    {showChangeSalesMan && (
      <ChangeSalesMan
        requestId={selectedOrderId}
        currentSalesman={currentSalesman}
        onClose={() => closeModal(false)}
        callFunc={refreshData}
        type={user?.type}
      />
    )}

                </>
            )}
        </div>
    );
};

export default AdminAllOrders;
